<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/officeLocations"
        >Content Management - Office Locations</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">
      Create Office Locations
    </h3>
    <div class="detailContent">
      <el-form
        label-width="50%"
        label-position="left"
        ref="formLocation"
        :model="formLocation"
        :rules="formLocationRules"
      >
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Country / Region" prop="country">
              <el-select v-model="formLocation.country" filterable>
                <el-option
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.name"
                  :value="item.countryId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Office Name / City (EN)" prop="cityEn">
              <el-input
                v-model="formLocation.cityEn"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Office Name / City (JP)" prop="cityJp">
              <el-input
                v-model="formLocation.cityJp"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Office Name / City (TC)" prop="cityTc">
              <el-input
                v-model="formLocation.cityTc"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Office Name / City (SC)" prop="citySc">
              <el-input
                v-model="formLocation.citySc"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Office address (EN)" prop="addressEn">
              <el-input
                v-model="formLocation.addressEn"
                placeholder="Please enter"
                type="textarea"
                resize="none"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Office address (JP)" prop="addressJp">
              <el-input
                v-model="formLocation.addressJp"
                placeholder="Please enter"
                type="textarea"
                resize="none"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Office address (TC)" prop="addressTc">
              <el-input
                v-model="formLocation.addressTc"
                placeholder="Please enter"
                type="textarea"
                resize="none"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Office address (SC)" prop="addressSc">
              <el-input
                v-model="formLocation.addressSc"
                placeholder="Please enter"
                type="textarea"
                resize="none"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Post online" prop="post">
              <el-radio v-model="formLocation.post" :label="true">On</el-radio>
              <el-radio v-model="formLocation.post" :label="false"
                >Off</el-radio
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Order" prop="order">
              <el-input v-model="formLocation.order" maxlength="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button v-if="showSave" class="reset" style="width: 100%" @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4">
        <el-button
          v-if="showSave"
          type="primary"
          style="width: 100%"
          @click="handleCreate"
          >Create</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCountry, officesAdd } from "@/request/api";
export default {
  name: "createOfficeLocation",
  data() {
    return {
      formLocationRules: this.$validation.locationCreate,
      formLocation: {
        cityEn: "",
        cityJp: "",
        cityTc: "",
        citySc: "",
        addressEn: "",
        addressJp: "",
        addressTc: "",
        addressSc: "",
        post: false,
        order: "",
        country: "",
      },
      countryList: [],
      showSave: true,
    };
  },
  methods: {
    getConfig() {
      getCountry().then((res) => {
        this.countryList = res.data;
      });
    },
    handleCancel() {
      this.$router.push("/officeLocations");
    },
    handleCreate() {
      this.$refs.formLocation.validate((valid) => {
        if (valid) {
          let params = {
            addressEn: this.formLocation.addressEn,
            addressJp: this.formLocation.addressJp,
            addressSc: this.formLocation.addressSc,
            addressTc: this.formLocation.addressTc,
            cityEn: this.formLocation.cityEn,
            cityJp: this.formLocation.cityJp,
            citySc: this.formLocation.citySc,
            cityTc: this.formLocation.cityTc,
            displayOrder: this.formLocation.order,
            post: this.formLocation.post,
            countryId: this.formLocation.country,
          };
          officesAdd(params).then((res) => {
            if (res.data.status == "00") {
              this.$message.success("New record is created");
              this.handleCancel();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },

    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },
  },
  created: function () {
    this.getConfig();
    this.showBtn("CONTENT_WRITE");
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/content/location/createOfficeLocation.vue